import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import {useAlert, useHttpClient} from '../../../modules/services/Bundle'
import {RequestMethod} from '../../../modules/services/core/_enums'
import {ResponderPesquisa} from './ResponderPesquisa'

const AcessoPesquisa = () => {
  const httpClient = useHttpClient()
  const alert = useAlert()
  const navigate = useNavigate()
  const routeParams = useParams()
  const chave = routeParams['chave'] ?? ''
  const [carregando, setCarregando] = useState(true)
  const [anonima, setAnonima] = useState(false)
  const [pesquisa, setPesquisa] = useState<any>(null)
  const [codigo, setCodigo] = useState('')
  const [iniciando, setIniciando] = useState(false)

  useEffect(() => {
    const obterAcesso = async () => {
      setCarregando(true)
      setAnonima(false)

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: '/Pesquisa/ResponderPesquisa/ObterAcessoAnonimo',
        queryObject: {
          chave,
        },
      })

      if (response.success && response.payload?.Anonima) {
        setAnonima(true)
        setPesquisa(response.payload.Pesquisa)
      }

      setCarregando(false)
    }

    obterAcesso()
  }, [chave])

  const iniciarPesquisa = async () => {
    setIniciando(true)

    const response = await httpClient.request({
      method: RequestMethod.POST,
      endpoint: '/Pesquisa/ResponderPesquisa/IniciarPesquisaAnonima',
      queryObject: {
        chave,
      },
    })

    if (response.success && response.payload?.Chave) {
      navigate(`/responder-pesquisa/${response.payload.Chave}`, {
        state: {
          codigoAnonimo: response.payload.Chave,
        },
      })
    }

    setIniciando(false)
  }

  const acessarComCodigo = () => {
    const codigoTratado = codigo.trim()

    if (!codigoTratado) {
      alert.createMessage({
        html: 'Informe o código da pesquisa para continuar.',
        icon: 'warning',
      })
      return
    }

    navigate(`/responder-pesquisa/${codigoTratado}`)
  }

  if (carregando) return null

  if (!anonima) return <ResponderPesquisa />

  return (
    <div className='container py-10'>
      <div className='card shadow-sm'>
        <div className='card-header'>
          <div className='card-title'>
            <h1 className='text-gray-800 mb-0'>{pesquisa?.Nome}</h1>
          </div>
        </div>
        <div className='card-body'>
          <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-8'>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-2tx svg-icon-primary me-4'
            />
            <div className='fw-bold'>
              <h4 className='text-gray-800 fw-bolder'>Pesquisa anônima</h4>
              <div className='fs-6 text-gray-600'>
                Ao iniciar, será gerado um código único. Salve esse código para continuar a pesquisa depois, se necessário.
              </div>
            </div>
          </div>

          <div className='row g-6'>
            <div className='col-lg-6'>
              <div className='border rounded p-6 h-100'>
                <h3 className='text-gray-800'>Iniciar nova resposta</h3>
                <div className='text-gray-600 mb-5'>
                  Essa ação vai iniciar sua resposta e gerar um código para continuar depois, se necessário.
                </div>
                <button
                  type='button'
                  className='btn btn-lg btn-pesquisa'
                  disabled={iniciando}
                  onClick={iniciarPesquisa}
                >
                  <span className='indicator-label'>
                    Iniciar
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-2 text-white me-0'
                    />
                  </span>
                </button>
              </div>
            </div>

            <div className='col-lg-6'>
              <div className='border rounded p-6 h-100'>
                <h3 className='text-gray-800'>Já tenho um código</h3>
                <div className='text-gray-600 mb-5'>
                  Use o código salvo anteriormente para continuar sua resposta.
                </div>
                <div className='d-flex flex-column flex-md-row gap-3'>
                  <input
                    className='form-control form-control-lg'
                    placeholder='Informe seu código'
                    value={codigo}
                    onChange={(event) => setCodigo(event.target.value)}
                  />
                  <button type='button' className='btn btn-lg btn-pesquisa' onClick={acessarComCodigo}>
                    Acessar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {AcessoPesquisa}
